import { TableHeadItemRecurse } from '../../../../../components/TableHead';

export const tableHead: TableHeadItemRecurse[] = [
  { title: 'Ativo' },
  { title: 'Emissor', flex: 1.6 },
  { title: 'Indexador' },
  { title: 'Tipo marcação' },
  { title: 'Qtd. disponível' },
  { title: 'Qtd. bloqueada' },
  { title: 'Qtd. total' },
  { title: 'Vencimento' },
  { title: 'Valor bruto', flex: 1.2 },
  { title: 'Variação', flex: 0.8 },
  { title: '', flex: 1.2 },
];
